import { render } from "./CourierDeliveryContent.vue?vue&type=template&id=fa36d120&scoped=true"
import script from "./CourierDeliveryContent.vue?vue&type=script&lang=js"
export * from "./CourierDeliveryContent.vue?vue&type=script&lang=js"

import "./CourierDeliveryContent.vue?vue&type=style&index=0&id=fa36d120&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa36d120"]])

export default __exports__